import React, { FC, useState } from 'react';
import { AnyFCO, FCOFields, FCOType } from '../../../core/types/fcoTypes';
import { IconType, Popover, Link, FlexGroup, FlexItem, Badge } from '@lithos';

const RelatedFCOsCell: FC<{ fcos: AnyFCO[]; type: FCOType; workspace: string }> = ({ fcos, type, workspace }) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState<boolean>(false);

  const typeIconMap: Record<FCOType, IconType> = {
    [FCOType.DATA_SOURCE]: 'Sources',
    [FCOType.ENTITY]: 'Entities',
    [FCOType.FEATURE_VIEW]: 'FeatureView',
    [FCOType.FEATURE_SERVICE]: 'FeatureService',
    [FCOType.TRANSFORMATION]: 'Transformations',
    [FCOType.DATASET]: 'Dataset',
    [FCOType.UNKNOWN]: 'AccountsAndAccess',
  };

  const linkToMap: Record<FCOType, string> = {
    [FCOType.DATA_SOURCE]: `/repo/${workspace}/data-sources/`,
    [FCOType.ENTITY]: `/repo/${workspace}/entities/`,
    [FCOType.FEATURE_VIEW]: `/repo/${workspace}/features/`,
    [FCOType.FEATURE_SERVICE]: `/repo/${workspace}/feature-services/`,
    [FCOType.TRANSFORMATION]: `/repo/${workspace}/transformations/`,
    [FCOType.DATASET]: `/repo/${workspace}/datasets/`,
    [FCOType.UNKNOWN]: `/repo/${workspace}/home/`,
  };

  if (fcos.length === 0) {
    return <>-</>;
  }

  if (fcos.length === 1) {
    return (
      <Link
        icon={typeIconMap[type]}
        name={fcos[0][FCOFields.NAME]}
        url={`${linkToMap[type]}${fcos[0][FCOFields.NAME]}`}
      />
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div
      onClick={(event) => {
        event.stopPropagation();
        setIsPopoverOpen(true);
      }}
    >
      <FlexGroup padding="0" gapSize="2" alignItems="flex-start">
        <FlexItem grow={0} shrink={1}>
          <Link
            name={fcos[0][FCOFields.NAME]}
            icon={typeIconMap[type]}
            url={`${linkToMap[type]}${fcos[0][FCOFields.NAME]}`}
          />
        </FlexItem>
        <FlexItem grow={0} shrink={0}>
          <Popover
            isOpen={isPopoverOpen}
            setIsOpen={setIsPopoverOpen}
            trigger={<Badge label={'+' + (fcos.length - 1)} size="xs" />}
            body={
              <FlexGroup direction="column" padding="0" gapSize="1">
                {fcos.map((fco) => {
                  return (
                    <Link
                      name={fco[FCOFields.NAME]}
                      icon={typeIconMap[type]}
                      url={`${linkToMap[type]}${fco[FCOFields.NAME]}`}
                    />
                  );
                })}
              </FlexGroup>
            }
          />
        </FlexItem>
      </FlexGroup>
    </div>
  );
};

export default RelatedFCOsCell;
